import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const marketingTagsApi = api
  .enhanceEndpoints({ addTagTypes: ["marketingTags"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createMarketingTag: builder.mutation({
        query: ({
          branchId,
          name,
          color,
          discount,
          business_name,
          tradename,
          tax_identification,
          code_postal,
          address,
          address_number,
          address_floor,
          location,
          city,
          province,
          responsible,
          email,
          financial_email,
          fees,
          fees_course,
        }) => ({
          url: `branchs/${branchId}/marketing-tags`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            type: 2,
            discount,
            business_name,
            tradename,
            tax_identification,
            code_postal,
            address: address,
            address_number,
            address_floor,
            location,
            city,
            province,
            responsible,
            email,
            financial_email,
            fees,
            fees_course,
          }),
        }),
        invalidatesTags: ["marketingTags"],
      }),
      updateMarketingTag: builder.mutation({
        query: ({
          branchId,
          name,
          price,
          currency,
          id,
          color,
          discount,
          business_name,
          tradename,
          tax_identification,
          code_postal,
          address,
          address_number,
          address_floor,
          location,
          city,
          province,
          responsible,
          email,
          financial_email,
          fees,
          fees_course,
        }) => ({
          url: `branchs/${branchId}/marketing-tags/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            name,
            price,
            currency,
            color,
            type: 2,
            discount,
            business_name,
            tradename,
            tax_identification,
            code_postal,
            address,
            address_number,
            address_floor,
            location,
            city,
            province,
            responsible,
            email,
            financial_email,
            fees,
            fees_course,
          }),
        }),
        invalidatesTags: ["marketingTags"],
      }),
      deleteMarketingTag: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `/branchs/${branchId}/marketing-tags/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["marketingTags"],
      }),
      marketingTags: builder.query({
        query: ({ branchId, type }) => ({
          url: `branchs/${branchId}/marketing-tags`,
          method: RequestMethod.GET,
          params: camelToSnake({
            type,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["marketingTags"],
      }),
      createUsersTag: builder.mutation({
        query: ({ branchId, name, color }) => ({
          url: `branchs/${branchId}/marketing-tags`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            type: 2,
          }),
        }),
        invalidatesTags: ["marketingTags"],
      }),
      updateUsersTag: builder.mutation({
        query: ({ branchId, name, price, currency, id }) => ({
          url: `branchs/${branchId}/marketing-tags/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            name,
            price,
            currency,
          }),
        }),
        invalidatesTags: ["marketingTags"],
      }),
      deleteUsersTag: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/marketing-tags/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["marketingTags"],
      }),
    }),
  });

export const {
  useMarketingTagsQuery,
  useCreateMarketingTagMutation,
  useUpdateMarketingTagMutation,
  useDeleteMarketingTagMutation,
} = marketingTagsApi;
